import React from "react";

const Hero = () => {
  return (
    <section className="mrv-hero-section">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
         poster={`${process.env.PUBLIC_URL}/assets/img/school_gate.webp`}
        className="mrv-hero-video"
      >
       
        <source
          src={`${process.env.PUBLIC_URL}/assets/img/hero.mp4`}
          type="video/mp4"
        />
      </video>

      <div className="mrv-hero-overlay"></div>
    </section>
  );
};

export default Hero;
